"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var __1 = require("../");
var enhance = (0, recompose_1.compose)((0, recompose_1.defaultProps)({
    hasCloseButton: true
}), (0, recompose_1.setDisplayName)('Header'), recompose_1.pure);
exports.Header = enhance(function (props) { return (React.createElement("div", { className: classNames('sok-header', props.className) },
    React.createElement("h3", { className: "header-text" },
        " ",
        props.children,
        " "),
    props.hasCloseButton && (React.createElement(__1.Icon, { className: 'fa-times fa-lg close-button', prefix: "fal", onClick: props.onClose })))); });
//# sourceMappingURL=index.js.map